/* eslint-disable max-len */
import React, { Component } from 'react'
import { items } from './data'
import MainTreeItem from './MainTreeItem'
import MainTreeItemContainer from './MainTreeItemContainer'
import styles from './s.module.css'

export default class Distancer extends Component {
  render () {
    let tree = []
    for (let i = 0; i < items.MT.length; i++) {
      const item = items.MT[i]
      if (Number.isInteger(item)) {
        tree.push(<MainTreeItem key={`mti${i}`} index={item} />)
      } else {
        let subItems = []
        for (let j = 0; j < item.i.length; j++) {
          subItems.push(<MainTreeItem key={`mti${100 + i + j}`} index={item.i[j]} />)
        }
        tree.push(
          <ul key={`mtix${i}`} className={styles.mainTreeCon}>
            <MainTreeItemContainer label={item.l}>{subItems}</MainTreeItemContainer>
          </ul>
        )
      }
    }
    return (
      <div className={styles.dist}>
        <h2>Nejmenší dovolené vzdálenosti při souběhu a křížení podzemních sítí</h2>
        <h4>podle ČSN 73 6005 Prostorové uspořádání sítí technického vybavení, tabulky A. 1 a A. 2</h4>
        <p>Vzdálenosti se měří mezi vnějšími povrchy kabelů, potrubí, stok, ochranné konstrukce nebo kolejnice bližší k vedení.</p>
        <ul className={styles.mainTree}>{tree}</ul>
        <p className={styles.distLink}>
          <a href="https://jesyka.cz/">jesyka.cz</a>
        </p>
      </div>
    )
  }
}
